import React from 'react';
import {Footer, HeaderNavi, SupportLeftMenu, FileList} from '@components';
import { useQuery } from '@tanstack/react-query';
import { get } from '@utils/axios_api';
import { useNavigate, useLocation } from 'react-router-dom';

const fetchNoticeDetail = async (noticeCode) => {
    const response = await get(`/noticeDetail/${noticeCode}`);
    return response;
};
const NoticeDetail = () => {
    // const BASE_URL = process.env.REACT_APP_BOOT_URL || 'http://localhost:8080';
    const location = useLocation();
    const navigate = useNavigate()

    const params = new URLSearchParams(location.search);
    const noticeCode = params.get('noticeCode');

    const { data, isLoading, isError } = useQuery({
        queryKey: ['noticeDetail', noticeCode],
        queryFn: () => fetchNoticeDetail(noticeCode),
        enabled: !!noticeCode,
    });


      if (isLoading) {
        return <div>로딩 중...</div>;
      }
    
      if (isError) {
        return <div>오류가 발생했습니다.</div>;
      }
    
      const detail = data?.result;

  return (
    <main id="main" className="mainpage">
            <>
            <div>
                <div className="section main-contact">
                    <HeaderNavi  selectedCategory  />
                    <div className="sub-container">
                        <div className="sub-layout">
                            <SupportLeftMenu />
                            <div className="sub-contact">
                                <h3 className="border-bt" style={{ marginBottom: '0' }}>공지사항</h3>
                                <div className="lineTop_tb01">
                                    <table className="lineTop_tb2 detail_tb">
                                    <colgroup>
                                        <col style={{ width: '130px' }} />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>제목</th>
                                            <td >{detail?.title}</td>
                                        </tr>
                                        <tr>
                                            <th>작성일</th>
                                            <td>{detail?.createdAt}</td>
                                        </tr>
                                        <tr>
                                            <th>조회수</th>
                                            <td>{detail?.viewcount}</td>
                                        </tr>
                                        <tr>
                                            <th>파일</th>
                                            <td >
                                                <FileList atchFileId={detail.atchFileId} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>내용</th>
                                            <td className="content_area" style={{height:"250px"}}>
                                            {/* <div dangerouslySetInnerHTML={{ __html: detail?.content || '' }} /> */}
                                            <div 
                                                dangerouslySetInnerHTML={{ 
                                                    // __html: detail?.content.replace(/\/uploaded_images\//g, BASE_URL + '/uploaded_images/') || '' 
//                                                     __html: detail?.content.replace(/\/uploaded_images\//g,  '/uploaded_images/') || ''
                                                    __html: detail?.content.replace(/\/uploaded_images\//g,  'http://edu.atos.co.kr:8082/uploaded_images/') || ''
                                                }}
                                            />
                                            </td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                                <button
                                        className="btn btn-bl mt10 ml10"
                                        onClick={() => navigate('/support/notice')}
                                    >
                                        목록
                                    </button>
                            </div>	
                        </div>	
                    </div>
                    <Footer />
                </div>
            </div>
        </>
   </main>


  );
};


export default NoticeDetail;
